import React from 'react';
import logoName from '../../assets/samasti-name.png';
import SamastixLogoMark from '../ui/SamastixLogoMark';

function LogoLink({ variant = 'default' }) {
  const isDark = variant === 'dark';

  if (isDark) {
    return (
      <a
        href="https://samastix.com"
        className="flex items-center select-none shrink-0 no-underline min-w-0 login-nav__logo-lockup"
        aria-label="Samastix home"
      >
        <img
          src={logoName}
          alt="Samastix"
          width={110}
          height={24}
          className="h-5 sm:h-6 w-auto object-contain max-w-[110px] sm:max-w-none login-nav__logo-invert"
        />
        <SamastixLogoMark variant="dark" className="login-nav__logo-mark shrink-0" />
      </a>
    );
  }

  return (
    <a
      href="https://samastix.com"
      className="flex items-center select-none shrink-0 no-underline min-w-0 nav-logo-lockup"
      aria-label="Samastix home"
    >
      <img
        src={logoName}
        alt="Samastix"
        width={110}
        height={24}
        className="h-5 sm:h-6 w-auto object-contain max-w-[110px] sm:max-w-none"
      />
      <SamastixLogoMark className="nav-logo-mark shrink-0" />
    </a>
  );
}

export default function LoginNavHeader() {
  return (
    <header className="login-nav fixed top-0 left-0 right-0 z-50 pointer-events-none">
      <div className="relative pointer-events-auto">
        <div className="login-nav__bar flex">
          <div className="login-nav__brand hidden lg:flex lg:w-[46%] xl:w-[48%] shrink-0 items-center px-10 xl:px-14">
            <LogoLink variant="dark" />
          </div>
          <div className="login-nav__panel flex-1 flex items-center px-4 sm:px-6 lg:px-10">
            <div className="lg:hidden">
              <LogoLink />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
